export const BILLING_USAGE_ROUTE_NAME = 'BillingUsage';
export const BILLING_USAGE_HISTORY_ROUTE_NAME = 'BillingUsageHistory';
export const BILLING_USAGE_OVERVIEW_ROUTE_NAME = 'BillingUsageOverview';
export const BILLING_USAGE_SETTINGS_ROUTE_NAME = 'BillingUsageSettings';
export const BILLING_USAGE_PAYMENT_METHODS_ROUTE_NAME = 'BillingUsagePaymentMethods';
export const BILLING_USAGE_INVOICE_HISTORY_ROUTE_NAME = 'BillingUsageInvoiceHistory';
export const BILLING_USAGE_HISTORY_AUTOMATION_ROUTE_NAME = 'BillingUsageHistoryAutomation';
export const BILLING_USAGE_HISTORY_PLY_CREDITS_ROUTE_NAME = 'BillingUsageHistoryPlyCredits';
export const BILLING_USAGE_HISTORY_TEAM_FEATURES_ROUTE_NAME = 'BillingUsageHistoryTeamFeatures';
export const BILLING_USAGE_HISTORY_CUSTOMER_FEATURES_ROUTE_NAME = 'BillingUsageHistoryCustomerFeatures';
